

    export default {
        name: 'ShareTickers',

        props: {
            share: Object
        }
    }
